import Lookup from './lookup.js';

export default class Institution extends Lookup
{
    
}
